import { Platform } from "@linkfluence/models/platform";
import { CorporaAPI } from "@radarly/api/corpora";
import { CorporaSourcePayload } from "@radarly/models/corpora";
import { CorporaRepo } from "./CorporaRepo";

export class ConnectedCorporaRepo implements CorporaRepo {
  api: CorporaAPI;
  public constructor() {
    this.api = new CorporaAPI();
  }
  public getCorporaTotalSourcesByPlatform(project: number) {
    return this.api.getCorporaTotalSourcesByPlatform(project);
  }
  public getCorporaPlatformSources(
    project: number,
    corpusId: number,
    platform: Platform,
    payload: CorporaSourcePayload
  ) {
    return this.api.getCorporaPlatformSources(
      project,
      corpusId,
      platform,
      payload
    );
  }
}
